import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { SHOP_DATA } from "../constants";
import routes from "../constants/routes";
import { checkExpiredShop } from "../helpers";
import useWindowDimensions from "../helpers/useWindowDimensions";

// Route Components
import PrivateRoute from "./PrivateRoute";
import ContactDrafts from "../pages/contactDrafts";
import PublicRoute from "./PublicRoute";

// Layout Components
import Navbar from "../layouts/Navbar";
import Sidenav from "../layouts/SideNav";

// Page Components
import Login from "../pages/login/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import TotalSummary from "../pages/totalSummary/TotalSummary";
import StocksInfo from "../pages/stocks/StocksInfo";
import ProductAdd from "../pages/products/productAdd/ProductAdd";
import ProductExcelAdd from "../pages/products/productAdd/ProductExcelAdd";
import ProductManager from "../pages/products/ProductManager";
import Orders from "../pages/orders/Orders";
import OrderAddV2 from "../pages/orders/orderAdd/OrderAddV2";
import OrderDetail from "../pages/orders/orderDetail/OrderDetail";
import OrderGroupDetail from "../pages/orders/OrderGroupDetail";
import OrderlistEdit from "../pages/dashboard/OrderlistEdit";
import OrderPrint from "../pages/dashboard/OrderPrint";
import OrderMove from "../pages/dashboard/OrderMove";
import LiveMange from "../pages/liveManage/LiveManage";
import LiveAdd from "../pages/liveManage/liveAdd/LiveAdd";
import LiveScreen from "../pages/liveManage/liveScreen/LiveScreen";
import LiveDetail from "../pages/liveManage/liveDetail/LiveDetail";
import LiveDetailCFWithUser from "../pages/liveManage/liveDetail/LiveDetailCFWithUser";
import SelectPageForLive from "../pages/liveManage/liveScreen/SelectPageForLive";
import LiveMarathon from "../pages/liveManage/liveMarathon/LiveMarathon";
import LiveMarathonPublic from "../pages/liveManage/liveMarathon/LiveMarathonPublic";
import PostFeed from "../pages/PostFeed/PostFeed";
import PostDetail from "../pages/PostFeed/postDetail/PostDetail";
import PostFeedAdd from "../pages/PostFeed/postFeedAdd/PostFeedAdd";
import PostDetailCFWithUser from "../pages/PostFeed/postDetail/PostDetailCFWithUser";
import Settings from "../pages/settings/Settings";
import SettingSPage from "../pages/settings/settingSalePage/SettingSPage";
import SettingsFacebook from "../pages/settings/SettingsFacebook";
import SettingsBank from "../pages/settings/SettingsBank";
import SettingsLive from "../pages/settings/SettingsLive";
import SettingsProfile from "../pages/settings/SettingsProfile";
import ViewStats from "../pages/viewStats/ViewStats";
import SettingsTag from "../pages/settings/SettingsTag";
import SettingsOptionValue from "../pages/settings/SettingsOptionValue";
import SettingBills from "../pages/settings/settingBills/SettingBills";
import SettingTextToSpeech from "../pages/settings/settingTextToSpeech";
import SettingOther from "../pages/settings/SettingOther";
import SettingAppV2 from "../pages/settings/SettingAppV2";
import OrderDeliveryStories from "../pages/history/OrderDeliveryStories";
import LogicticsPage from "../pages/settings/settingLogictics/LogicticsPage";
import ExchangeRate from "../pages/settings/ExchangeRate";
import Advertising from "../pages/settings/Advertising";
import InvoiceOrderDatas from "../pages/wallets/WalletStore";
import CommisionPage from "../pages/settings/settingSalePage/CommisionPage";
import InvoiceList from "../pages/invoices/InvoiceList";
// import CreateInvoice from "../pages/invoices/CreateInvoice";
import InvoiceRequesting from "../pages/invoices/InvoiceRequesting";
import UsersCF from "../pages/userCF/UserCF";
import CustomerCFList from "../pages/customerCF/CustomerCFList";
import CustomerCFDetail from "../pages/customerCF/CustomerCFDetail";
import InfulancerListPage from "../pages/infulancer/InfulancerListPage";
import SystemNoticeDetail from "../pages/systemNotice/SystemNoticeDetail";
import MessengerInbox from "../pages/messengerInbox/MessengerInbox";
// import SideBar from "../layouts/SideBar";
import CompletedPayment from "../pages/orders/OrderConfirm/CompletedPayment";
import PrivacyPolicy from "../pages/policy/PrivacyPolicy";
import OrderConfirm from "../pages/orders/OrderConfirm/OrderConfirm";
import FindOrder from "../pages/orders/FindOrder/FindOrder";
import MyOrder from "../pages/orders/MyOrder/MyOrder";
import ConfirmFillsForm from "../pages/checkOutOrder/ConfirmFillsForm";
import ClaimBalance from "../pages/orders/OrderConfirm/ClaimBalance";
import ShowOnairLiveScreen from "../pages/liveManage/liveScreen/ShowOnairLive";
import HelpCenter from "../pages/helpCenter/HelpCenter";
import ConfirmPayment from "../pages/orders/conform-payment/ConfirmPayment";
// import DashboardAnalytics from "../pages/dashboard/DasbhoardAnality";
import OrderSalePageTab from "../pages/invoices";

const Main = styled.main`
  overflow: hidden;
  transition: all 0.15s;
  padding: 0 10px;
  margin-left: ${(props) => (props.expanded ? 240 : 60)}px;
`;

const DESKTOP_WIDTH = 700;

const Index = () => {
  const { width } = useWindowDimensions();
  const [expanded, setExpanded] = useState(false);
  const shopData = JSON.parse(localStorage.getItem(SHOP_DATA));

  useEffect(() => {
    if (shopData) {
      checkExpiredShop(shopData);
    }
  }, [shopData]);

  const checkSubscriptionStatus = () => {
    if (!shopData) return { check: false };

    if (shopData.paymentType === "POINT" && shopData.point <= 1000000) {
      return { check: true, point: shopData.point };
    }

    if (shopData.paymentType === "SUBSCRIPTION") {
      const daysRemaining = moment(shopData.endDate).diff(moment(), "days");
      if (daysRemaining < 3) {
        return { check: true, day: daysRemaining };
      }
    }

    return { check: false };
  };

  const renderPrivateRoutes = () => (
    <>
      {/* Dashboard & Summary */}
      <PrivateRoute exact path="/dashboard" component={Dashboard} />
      {/* P5 — contact details a buyer was asked to confirm and has not. */}
      <PrivateRoute exact path="/contact-drafts" component={ContactDrafts} />
      <PrivateRoute exact path="/total-summary" component={TotalSummary} />

      {/* Products */}
      <PrivateRoute exact path="/products/limit/:limit/page/:skip" component={StocksInfo} />
      <PrivateRoute exact path="/product-add" component={ProductAdd} />
      <PrivateRoute exact path="/product-exceal-add" component={ProductExcelAdd} />
      <PrivateRoute path="/product-edit/:productId" component={ProductAdd} />
      <PrivateRoute path="/productmanager" component={ProductManager} />

      {/* Orders */}
      <PrivateRoute exact path="/orders/limit/:limit/page/:skip" component={Orders} />
      {/* <PrivateRoute exact path="/orders-add" component={OrderAdd} /> */}
      <PrivateRoute exact path="/orders-add" component={OrderAddV2} />
      <PrivateRoute exact path="/orders-detail" component={OrderDetail} />
      <PrivateRoute path="/ordergroupdetail/:orderId" component={OrderGroupDetail} />
      <PrivateRoute path="/orderlistEdit" component={OrderlistEdit} />
      <PrivateRoute path="/orderprint" component={OrderPrint} />
      <PrivateRoute path="/ordermove" component={OrderMove} />

      {/* Live Management */}
      <PrivateRoute exact path="/live-manage/:liveType/limit/:limit/page/:skip" component={LiveMange} />
      <PrivateRoute path="/live-add" component={LiveAdd} />
      <PrivateRoute exact path="/live-screen/:liveId" component={LiveScreen} />
      <PrivateRoute exact path="/live-detail" component={LiveDetail} />
      <PrivateRoute exact path="/live-user-detail" component={LiveDetailCFWithUser} />
      <PrivateRoute exact path="/like-select-page" component={SelectPageForLive} />
      <PrivateRoute exact path="/live-marathon/:liveId" component={LiveMarathon} />

      {/* Posts & Feeds */}
      <PrivateRoute exact path="/post-feed" component={PostFeed} />
      <PrivateRoute exact path="/post-detail" component={PostDetail} />
      <PrivateRoute exact path="/post-feed-add" component={PostFeedAdd} />
      <PrivateRoute exact path="/post-user-detail" component={PostDetailCFWithUser} />

      {/* Settings */}
      <PrivateRoute exact path="/settings" component={Settings} />
      <PrivateRoute exact path="/setting-salepage" component={SettingSPage} />
      <PrivateRoute exact path="/settings-facebook" component={SettingsFacebook} />
      <PrivateRoute exact path="/settings-bank" component={SettingsBank} />
      <PrivateRoute exact path="/settings-live" component={SettingsLive} />
      <PrivateRoute exact path="/settings-profile" component={SettingsProfile} />
      <PrivateRoute exact path="/view-stats" component={ViewStats} />
      <PrivateRoute exact path="/settings-tag" component={SettingsTag} />
      <PrivateRoute exact path="/settings-option-value" component={SettingsOptionValue} />
      <PrivateRoute exact path="/settting-bills" component={SettingBills} />
      <PrivateRoute exact path="/tts-cloud" component={SettingTextToSpeech} />
      <PrivateRoute exact path="/setting-other" component={SettingOther} />
      <PrivateRoute exact path="/setting-app-v2" component={SettingAppV2} />

      {/* Delivery & Logistics */}
      <PrivateRoute exact path="/stored_delivery/limit/:limit/page/:skip" component={OrderDeliveryStories} />
      <PrivateRoute exact path="/logictics" component={LogicticsPage} />

      {/* Financial */}
      <PrivateRoute exact path="/exchange-rate" component={ExchangeRate} />
      <PrivateRoute exact path="/advertising-sale-page" component={Advertising} />
      <PrivateRoute exact path="/wallet_store/limit/:limit/page/:skip" component={InvoiceOrderDatas} />
      <PrivateRoute exact path="/commision-form" component={CommisionPage} />

      {/* Invoices */}
      <PrivateRoute exact path="/invoices" component={InvoiceList} />
      {/* <PrivateRoute exact path={routes.CREATE_INVOICE} component={CreateInvoice} /> */}
      <PrivateRoute exact path={routes.CREATE_INVOICE} component={OrderSalePageTab} />
      <PrivateRoute exact path={routes.REQUESTING_INVOICE} component={InvoiceRequesting} />

      {/* Users & Influencers */}
      <PrivateRoute exact path="/user-cf" component={UsersCF} />
      <PrivateRoute exact path="/customer-cf-list" component={CustomerCFList} />
      <PrivateRoute exact path="/customer-cf-detail/:userFbId" component={CustomerCFDetail} />
      <PrivateRoute exact path={routes.INFULANCER_LINK_LIST} component={InfulancerListPage} />

      {/* Messenger */}
      <PrivateRoute exact path="/messenger-inbox" component={MessengerInbox} />

      {/* Notifications & System */}
      <PrivateRoute exact path="/notice/:id" component={SystemNoticeDetail} />
      {/* <PrivateRoute exact path="/dashbroad-side-bar" component={SideBar} /> */}
    </>
  );



  const renderRoutes = () => (
    <div style={{ marginTop: width > DESKTOP_WIDTH ? 60 : "4em", marginLeft: width > DESKTOP_WIDTH ? 0 : 0 }}>
      {renderPrivateRoutes()}
    </div>
  );

  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/" component={Login} />
        <PublicRoute exact path="/completed-payment" component={CompletedPayment} />
        <PublicRoute exact path="/privacy-policy" component={PrivacyPolicy} />
        <PublicRoute exact path="/order-confirm/:data" component={OrderConfirm} />
        {/* STAGE B: the shop pins ONE link per Facebook Page, so a buyer whose bill has
            not arrived can confirm their order exists instead of commenting again and
            creating a duplicate. Shop-scoped, not page-scoped: a Facebook Page is not unique to a shop, and it covers post
            comments too, and never needs regenerating for a new broadcast. */}
        <PublicRoute exact path="/find-order/:shopId" component={FindOrder} />
        {/* The buyer's own order, behind a signed opaque token. The token is the credential,
            which is why this needs no login and asks for nothing — and why it must never be
            the orderGroup id, which was measured derivable (see helper/orderToken.js). */}
        <PublicRoute exact path="/o/:token" component={MyOrder} />
        <PublicRoute exact path="/confirm_payment/:data" component={ConfirmPayment} />
        <PublicRoute exact path="/checkout-order/:data" component={ConfirmFillsForm} />
        <PublicRoute exact path="/claim-balance/:data" component={ClaimBalance} />
        <PublicRoute exact path="/onair-live/shop/:shopId/live/:liveId" component={ShowOnairLiveScreen} />
        <PublicRoute exact path="/live-marathon-public/:liveId" component={LiveMarathonPublic} />
        <PublicRoute exact path="/help-center" component={HelpCenter} />
        <Route
          render={({ location, history }) => (
            <>
              <Navbar />
              <Sidenav
                location={location}
                history={history}
                onToggle={setExpanded}
              />
              {width > DESKTOP_WIDTH ? (
                <Main expanded={expanded}>{renderRoutes()}</Main>
              ) : (
                renderRoutes()
              )}
            </>
          )}
        />
      </Switch>
    </Router>
  );
};

export default Index;